export default function AdminAmlPolicyPage() {
  return <div className="p-4">AML policy</div>;
}
